import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface IncomeChartProps {
  data: any[];
  formatCurrency: (value: number, compact?: boolean) => string;
}

export const IncomeChart: React.FC<IncomeChartProps> = ({
  data,
  formatCurrency
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
        <XAxis dataKey="year" tick={{fontSize: 12}} />
        <YAxis tickFormatter={(value) => formatCurrency(value, true)} tick={{fontSize: 12}} />
        <Tooltip formatter={(value: number) => [formatCurrency(value), '']} />
        <Legend />
        <Bar dataKey="annualRent" fill="#3b82f6" name="Annual Rent" />
        <Bar dataKey="expenses" fill="#ef4444" name="Total Expenses" />
        <Bar dataKey="netRentalIncome" fill="#10b981" name="Net Income (After Tax)" />
      </BarChart>
    </ResponsiveContainer>
  );
};